import * as React from 'react';

interface IPopoverProps {
  children: any;
  type?: string;
}
interface IChildrenProps {
  children: any;
}
interface IPopoverState {
  isOpened: boolean;
}

class Popover extends React.Component<IPopoverProps> {
  public state: IPopoverState;
  private node: any;

  constructor(props: IPopoverProps) {
    super(props);
    this.state = {
      isOpened: false
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  public handleClick() {
    if (!this.state.isOpened) {
      document.addEventListener('click', this.handleOutsideClick);
    } else {
      document.removeEventListener('click', this.handleOutsideClick);
    }

    this.setState({ isOpened: !this.state.isOpened });
  }

  public handleOutsideClick(e: any) {
    if (this.node && (this.node || '').contains(e.target)) {
        return;
    }

    this.handleClick();
  }

  public render() {
    const name: string = 'popover';
    const { children, type } = this.props;

    return (
      <div
        ref={node => {
          this.node = node;
        }}
        className={name + (type ? ' ' + name + '--' + type : '')}
      >
        <div className="popover__toggler" onClick={() => this.handleClick()}>
          {children[0]}
        </div>
        {this.state.isOpened &&
          <div className="popover__content">{children[1]}</div>}
      </div>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// ./src/modules/Popover/Popover.tsx